import { useEffect, useRef } from "react";
import CloseButton from "./CloseButton";

const Modal = ({
  isOpen,
  setIsOpen,
  closeBtnPos = "left",
  type = "small",
  children,
}) => {
  const panelRef = useRef();

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        setIsOpen();
      }
    };

    const handleKeydown = (e) => {
      if (e.key === "Escape") {
        setIsOpen();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeydown);

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeydown);
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen, setIsOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[1005] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 animate-[modalFadeIn_0.15s_ease-out]">
      <div
        ref={panelRef}
        className={`relative bg-white w-full shadow-2xl ring-1 ring-black/5 flex flex-col animate-[modalScaleIn_0.18s_ease-out] ${
          type === "small"
            ? "max-w-lg max-h-[85vh] rounded-2xl"
            : "max-w-3xl h-[92dvh] md:h-auto md:max-h-[85vh] rounded-t-3xl md:rounded-2xl"
        }`}
      >
        <div className="h-1.5 w-full rounded-t-2xl md:rounded-t-2xl bg-gradient-to-r from-khamco-ribbon to-khamco-primary shrink-0" />
        <CloseButton closeBtnPos={closeBtnPos} actionFunction={setIsOpen} />
        <div className="overflow-y-auto p-6 md:p-8">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
